import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campus, Consentement, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { useForms, useSalesforce, useUrlReturn } from "hooks"
import { defaultValues, getAcademicLevels, salutations } from "services"
import MentionsLegales from "components/MentionsLegales"
import Formations from "../components/Formations"
import formations from "../services/formations.json"
import { constructParams } from "../services/functions"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('SUPINFO-DOC')
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      formations: [],
      lead: {
        ...defaultValues,
        Apprenticeship__c: false,
        Bachelor__c: false,
        MSc__c: false,
        Passerelle__c: false,
        PostalCode: '',
        Salutation: ''
      },
      specialites: []
    },
    resolver: yupResolver(schema)
  })
  const { control, watch } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const defaultDataLead = {
      Company: lead.FirstName + ' ' + lead.LastName,
      Is_From_Web__c: true,
      LeadSource: 'Demande de doc',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      await salesforce.createLead(finalLead)
      const params = constructParams(data.formations, formations)
      document.location.href=`${url}?campus=${campus}${params}`
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const campus = watch('lead.Campus__c')
  // useEffect
  useSalesforce('SUPINFO', true)

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel options={getAcademicLevels('SUPINFO')} section={false} specialites={false} />
        <Formations />
        <Grid item xs={12}>
          <InputText control={control} label="Code postal" name="lead.PostalCode" />
        </Grid>
        <Campus label="Campus souhaité" />
        <Consentement form="Documentation" school="SUPINFO" />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Documentation" school="SUPINFO" />
      </Grid>
    </FormProvider>
  )
}

export default Form
